<template>
  <button
    class="button"
    :class="{
      'button--corrupt': corrupt
    }"
  >
    <svg
      width="22"
      height="34"
      viewBox="0 0 22 34"
      xmlns="http://www.w3.org/2000/svg"
      class="heart heart-left"
      :class="{
        'heart-left--corrupt': corrupt
      }"
    >
      <path
        d="M21.442 29.338l-4.2-3.982 3.993-4.06-4.336-4.111 4.321-4.393-4.594-4.355 3.444-3.501C17.943 2.199 14.762.109 11.244.17 5.063.278.096 5.86.214 12.61.402 23.378 12.277 30.387 17.78 33.06l3.662-3.723z"
        fill="#FFF"
        fill-rule="evenodd"
      />
    </svg>
    <svg
      width="23"
      height="35"
      viewBox="0 0 23 35"
      xmlns="http://www.w3.org/2000/svg"
      class="heart heart-right"
      :class="{
        'heart-right--corrupt': corrupt
      }"
    >
      <path
        d="M4.32 12.806L.116 17.127l4.078 4.19-3.887 3.994 3.95 4.059-3.564 3.662a36.106 36.106 0 0 0 2.609 1.274s19.067-8.066 19.067-22.05C22.47 5.447 17.626 0 11.713 0 8.348 0 5.34 2.147 3.352 4.923L0 8.367l4.32 4.439z"
        fill="#FFF"
        fill-rule="evenodd"
      />
    </svg>
  </button>
</template>

<script>
export default {
  name: 'Heart',
  props: {
    corrupt: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba($c-red, 0.7);
  }
  70% {
    box-shadow: 0 0 0 25px rgba($c-red, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba($c-red, 0);
  }
}

@keyframes corruptButton {
  from {
    transform: scale(1);
  }
  35% {
    transform: scale(1.33);
  }
  75% {
    transform: scale(1);
    background-color: $c-red;
  }
  100% {
    background-color: #535252;
  }
}

.button {
  position: absolute;
  width: 75px;
  height: 75px;
  border-radius: 50%;
  background-color: $c-red;
  outline: 0;
  border: none;
  z-index: 20;
  bottom: -38px;
  left: 0;
  right: 0;
  margin: 0 auto;
  cursor: pointer;
  box-shadow: 0 0 0 rgba($c-red, 0.7);
  animation: pulse 2s infinite;
  transition: all 800ms ease-in-out;

  &--corrupt {
    box-shadow: none;
    animation: corruptButton 1600ms forwards;
    cursor: default;
  }
}
.heart {
  position: absolute;
  transition: all 1600ms ease-in-out 1600ms;
  transform: translate(0px, 0px) rotate(0deg);
}
.heart-left {
  top: 23px;
  right: 35px;

  &--corrupt {
    transform: translate(-5px, -4px) rotate(-10deg);
  }
}
.heart-right {
  top: 23px;
  left: 34px;

  &--corrupt {
    transform: translate(4px, 2px) rotate(8deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/social/Heart.vue